var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconToastError = function SvgIconToastError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#FFEFEF",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FA3C3C",
    fillRule: "evenodd",
    d: "M9.513 20.013a1.75 1.75 0 1 0 2.474 2.474L16 18.475l4.013 4.012a1.75 1.75 0 1 0 2.474-2.474L18.476 16l4.012-4.013a1.75 1.75 0 0 0-2.474-2.474L16 13.525l-4.012-4.012a1.75 1.75 0 0 0-2.475 2.474L13.525 16z",
    clipRule: "evenodd"
  })));
};
export default SvgIconToastError;